import { useLang, LANGUAGES } from "@/i18n";

export const LanguageSwitcher = ({ variant = "header" }) => {
  const { lang, setLang } = useLang();
  const bg = variant === "footer" ? "text-primary-foreground/80" : "text-foreground/70";
  return (
    <div data-testid="lang-switcher" className={`flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] ${bg}`} role="group" aria-label="Sprache wählen">
      {LANGUAGES.map((l, i) => (
        <span key={l.code} className="flex items-center gap-1">
          <button
            type="button"
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            aria-label={l.full}
            aria-current={lang === l.code ? "true" : undefined}
            className={`px-1 py-0.5 transition-opacity ${lang === l.code ? "opacity-100 font-medium underline underline-offset-4 decoration-1" : "opacity-60 hover:opacity-100"}`}
          >
            {l.label}
          </button>
          {i < LANGUAGES.length - 1 && <span className="opacity-30">·</span>}
        </span>
      ))}
    </div>
  );
};
